import { ArrowUp } from "lucide-react";
import { profile } from "../../data/content";
import { Logo } from "../Logo";

export const Footer = () => {
  const onTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-edge-650 mt-8">
      <div className="container-page py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Logo className="h-14 w-auto" />
            <p className="mt-5 text-sm text-zinc-400 max-w-xs">Creator of IMMBrain. Builder of real world systems.</p>
          </div>

          <div>
            <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-zinc-500 mb-4">Elsewhere</div>
            <ul className="space-y-2">
              {profile.socials.map((s) => (
                <li key={s.label}>
                  <a href={s.href} target="_blank" rel="noopener noreferrer" className="text-sm text-zinc-300 hover:text-white transition-colors inline-flex items-center gap-2">
                    <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-magenta-300 w-6">{s.short}</span>
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-zinc-500 mb-4">Resources</div>
            <ul className="space-y-2">
              <li><a href="/resume.pdf" target="_blank" rel="noopener noreferrer" className="text-sm text-zinc-300 hover:text-white transition-colors" data-testid="footer-resume-link">Resume (PDF)</a></li>
              <li><a href="#projects" className="text-sm text-zinc-300 hover:text-white transition-colors">Case studies</a></li>
              <li><a href="#contact" className="text-sm text-zinc-300 hover:text-white transition-colors">Get in touch</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-edge-650 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-zinc-500">©{year} malickecase.com · The journey continues.</div>
          <button onClick={onTop} data-testid="footer-top-button" className="inline-flex items-center gap-2 rounded-xl border border-edge-700 px-3 py-2 text-xs text-zinc-300 hover:border-magenta-500/60 hover:text-white transition-colors">
            Back to top <ArrowUp className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>
    </footer>
  );
};
